function ebTemplateToggleTOC() {
  const tocList = document.querySelector('.eb-template-toc-list');
  tocList.style.display = tocList.style.display === 'none' ? 'block' : 'none';
}
  document.addEventListener("DOMContentLoaded", function () {
    const tocToggleBtn = document.querySelector('.eb-template-toc-toggle');

    if (tocToggleBtn && !tocToggleBtn.getAttribute('onclick')) {
      tocToggleBtn.setAttribute('onclick', 'ebTemplateToggleTOC()');
    }
  });